<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->

    <!-- /.content-header -->

    <!-- Main content -->
    <section  class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">جدول دریافتی های کتاب</h3>
                <div class="card-tools">
                  <div class="input-group input-group-sm insert_box">
                 
                  </div>
                </div>
              </div>
              <template v-if="!status">
              
                 <div v-if="Items" class="card-body table-responsive p-0">
               <table class="table table-hover">
    <tr>
      <template v-for="(header, index) in headers">
        <th v-if="header.show_in_tabel == true" :key="index">
          {{ header.name }}
        </th>
      </template>
    </tr>
    <template v-if="Items.length > 0">
      <tr v-for="item in Items" :key="item.id">
        <template v-for="(header, index) in headers">
          <td
            v-if="header.type != 'setting' && header.show_in_tabel == true"
            :key="index + 20"
          >
            <span
              v-if="header.type == 'boolean'"
              class="badge"
              :class="{
                'badge-success': item[header.key] != null,
                'badge-warning': item[header.key] == null
              }"
            >
              {{ item[header.key] == null ?"مشاهده نشده" : new Date(item[header.key]).toLocaleString("fa")}}
            </span>
          <a target="_blank" v-if="header.type=='file'" :href="item[header.key]">مشاهده کتاب</a>
            <span v-if="header.type == 'string'">{{ item[header.key] }}</span>
            <span class="longText" v-if="header.type == 'description' &&item[header.key]!=null">{{
              item[header.key].length > 31
                ? item[header.key].slice(0, 31) + "..."
                : item[header.key]
            }}</span >
         <span  class="longText" v-if="header.type == 'description' &&item[header.key]==null">ندارد</span>
          </td>
          <td v-if="header.type == 'setting'" :key="index + 20">
            <b-button
              class="tableButtons"
              v-if="header.edit == true &&item.viewed_at==null"
              variant="primary"
              @click="acceptBook(item.id)"
              >تایید</b-button
            >
            <b-button
              class="tableButtons"
              v-if="header.delete == true"
              variant="danger"
              @click="deleteItem(item.id)"
              >حذف</b-button
            >
          </td>
        </template>
      </tr>
    </template>
  </table>
              </div> 
                
              </template>
              <!-- /.card-header -->
              

              <!-- /.card-body -->
              <!-- <div class="card-footer">
                <b-button variant="warning"
                 @click="showDraggableTable()"
                >
الویت بندی
                </b-button>
              </div> -->
            </div>
            <!-- /.card -->
          </div>
        </div>
        <div class="d-flex justify-content-center" v-if="!status">
          <pagination
          :limit="3"
          v-if="fullData!=null"
            :data="fullData"
            @pagination-change-page="changePage"
            :disabled="status"
          ></pagination>
        </div>
      </div>
    </section>
    <Loading :show_loading="status" />


    <!-- /.content -->
  </div>
</template>
<script>
import Loading from "@/components/admin/loading.vue";
import mixin from "../../mixins/mixins";
import STable from "@/components/mainComponent/STable.vue";
import {BFormInput,BButton} from "bootstrap-vue"
export default {  metaInfo() {
    return {
      title: "ناشرین",
    }
  },
  components: {
    Loading,
    STable,BFormInput,BButton
  },
  mixins: [mixin],
  data() {
    return {
      searchName:null,
      routeKey: "requestPublishBooks",
      showpModal: false,
      headers: [
        {
          style:"col-12",
          show_in_tabel:true,
          placeholder: "نام درخواست کننده",
          type: "string",
          name: "نام درخواست کننده",
          key: "name"
        },
        
        {
          style:"col-12",
          show_in_tabel:true,
          placeholder: "شماره تلفن",
          type: "string",
          name: "شماره تلفن",
          key: "mobile"
        },
        {
          style:"col-12",
          show_in_tabel:true,
          placeholder: "ایمیل",
          type: "string",
          name: "ایمیل",
          key: "email"
        },
        
        {
          style:"col-12",
          show_in_tabel:true,
          placeholder: "توضیحات",
          type: "description",
          name: "توضیحات",
          key: "description"
        },
        {
          style:"col-12",
          show_in_tabel:true,
          placeholder: "فایل",
          type: "file",
          name: "فایل",
          key: "file"
        },
        
        {
          style:"col-12",
          show_in_tabel:true,
          placeholder: "وضعیت مشاهده",
          type: "boolean",
          name: "وضعیت مشاهده",
          key: "viewed_at"
        },
        
        
        {
          style:"col-12",
          show_in_tabel:true,
          placeholder: "",
          type: "setting",
          name: "تنظیمات",
          key: "",
          edit: true,
          delete: true
        }
      ],
      mode: "create",
     edit_item:null,
      current_url: "/admin/request-publish-books",
      
    };
  },
  created() {
    if (this.Items == null) {
      
      this.getItemsFromServer(
        this.current_url,
        this.$route.query.page != undefined ? this.$route.query.page : "1",
        false,
        "",
        this.routeKey
      );
    }
  },
  methods: {
    showPostModal() {
      this.mode = "create";

      // this.$bvModal.show("postModal");
      this.showpModal = true;
    },
    acceptBook(id){
        this.$swal({
          icon: "info",
          title: "",
          showConfirmButton: true,
          text: "لطفا منتظر باشید",
          button: "باشه",
          timer:1500
        });
        this.$axios.get(`/admin/request-publish-books/${id}`).then(res=>{
            this.$swal({
          icon: "success",
          title: "تایید",
          showConfirmButton: true,
          text: "عملیات با موفقیت انجام شد",

          button: "باشه"
        });
        this.Items.forEach(item=>{
            if(item.id==id){
                item.viewed_at=new Date();
            }
        })
        })
    }
  },
  watch:{
    searchName(newVal){
      if(newVal == null||newVal==""||newVal==" "){
      this.$router.replace({ name: "requestPublishBooks", query: {page: "1"} })

      }else{

        this.getItemsFromServer(this.current_url,1,true,`&searchBy1=name&search1=${newVal}`,this.routeKey)
      }
    }
  }
};
</script>
